import React, { useEffect, useState } from "react";

import { Route, Routes, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { checkAuthThunk } from "@/features/auth/redux/auth.slice";
import { useAppSelector } from "@/redux/store";

import ProtectedRoute from "./components/ProtectedRoute";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css";
import { ThemeProvider } from "./styles/themes/theme-provider";
import "./App.css";

// Public routes
import LandingPage from "@/features/LandingPage";
import DownloadPage from "@/features/LandingPage/Download";
import LoginScreen from "@/features/auth/screens/LoginScreen/LoginScreen";

// Protected routes
import Default from "./components/layout/Default";

function App() {
  const dispatch = useDispatch();
  const { user, loginSuccess } = useAppSelector((state) => state.auth);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        setIsCheckingAuth(true);
        await dispatch(checkAuthThunk() as any);
      } catch (error) {
        console.error("Auth check error:", error);
      } finally {
        setIsCheckingAuth(false);
      }
    };

    checkAuth();
  }, [dispatch]);

  if (isCheckingAuth) {
    return (
      <ThemeProvider
        defaultTheme="light"
        storageKey="ui-theme"
      >
        <div className="app flex items-center justify-center min-h-screen">
          <div className="text-center">
            <p className="mt-4 text-sm text-gray-600">
              Đang kiểm tra đăng nhập...
            </p>
          </div>
        </div>
      </ThemeProvider>
    );
  }

  const isAuthenticated = Boolean(user) || loginSuccess;

  return (
    <ThemeProvider
      defaultTheme="light"
      storageKey="ui-theme"
    >
      <Routes>
        <Route
          path="/home"
          element={<LandingPage />}
        />
        <Route
          path="/download"
          element={<DownloadPage />}
        />
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate
                to="/"
                replace
              />
            ) : (
              <LoginScreen />
            )
          }
        />

        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Default />
            </ProtectedRoute>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
